var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeightLossSimpleChart = function SvgWeightLossSimpleChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 387 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#weight-loss-simple-chart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.5 201-5 22c41.361-3.309 60.5 20.5 88.5 41.5C128.56 78.96 104 90 228.5 98c9.64.62 31.507-1.531 37.5 0v103H-3.5Z",
    fill: "url(#weight-loss-simple-chart_svg__b)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.5 22c70.5 6.5 62 32 114 55.5S224.263 97.474 271 97c46.737-.474 61.664-46.804 116-55",
    stroke: "url(#weight-loss-simple-chart_svg__c)",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197 73 .006 19.881",
    stroke: "#3FA134",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.979 97c0 2.211-1.788 4-3.99 4A3.995 3.995 0 0 1 193 97c0-2.211 1.788-4 3.989-4a3.995 3.995 0 0 1 3.99 4Z",
    fill: "#3FA134",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.977 110-.003-8.881",
    stroke: "#C89207",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.002 97c0-2.211 1.788-4 3.989-4a3.995 3.995 0 0 1 3.989 4c0 2.21-1.788 4-3.989 4a3.995 3.995 0 0 1-3.989-4Z",
    fill: "#C89207",
    stroke: "#fff",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "weight-loss-simple-chart_svg__b",
    x1: 230.5,
    y1: -21.252,
    x2: 230.5,
    y2: 200.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA134",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "weight-loss-simple-chart_svg__c",
    x1: -3.5,
    y1: 59.739,
    x2: 462.5,
    y2: 59.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#3FA134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C89207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C89207"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "weight-loss-simple-chart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h387v156H0z"
  })))));
};
export default SvgWeightLossSimpleChart;